import { DataService } from '../../services/data_service';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DateneingabeDatencheckProps extends React.ClassAttributes<any> {
    data: any;
}

interface DateneingabeDatencheckState {
    refData?: any;
    refTid?: number;
    loadError: boolean;
    onlyErrors: boolean;
}

export class DateneingabeDatencheck extends
    React.Component<DateneingabeDatencheckProps, DateneingabeDatencheckState> {

    constructor(props: any) {
        super(props);
        this.state = {
            loadError: false,
            onlyErrors: true
        };
        this.load = this.load.bind(this);
        this.save = this.save.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    private currentData: any;

    componentDidMount(): void {
        this.load();
    }

    load(): void {
        this.dataService.loadData(IDs.ENT_DATENCHECK, {}, { resolve: true }, (res: any) => {
            if (!res || !res.datencheck) {
                this.setState({ loadError: true });
            } else {
                if (res.datencheck.length === 0) {
                    this.setState({ refData: {} });
                } else {
                    const plain = atob(res.datencheck[0].daten);
                    const refTid = res.datencheck[0].tid;
                    const refData = JSON.parse(plain);

                    this.setState({ refData, refTid });
                }
            }
        }, IDs.MOD_ETOOL);
    }

    save(): void {
        const daten = btoa(JSON.stringify(this.currentData));
        const saveItem = { tid: this.state.refTid || 0, daten };
        this.dataService.saveData(IDs.ENT_DATENCHECK, saveItem, null, false, (suc: boolean, saveTid: number) => {
            alert('Gespeichert');
            this.load();
        }, IDs.MOD_ETOOL);
    }

    render(): JSX.Element {
        if (!this.state.refData && !this.state.loadError) {
            return <div>Lade ...</div>;
        }
        const flatData = this.flattenData();
        this.currentData = flatData;
        const refData = this.state.refData;
        let errCnt = 0;
        Object.keys(flatData).forEach((k: string) => {
            const current = flatData[k];
            const ref = refData[k];
            if (ref) {
                if (current.value === ref.value) {
                    current.status = 'OK';
                } else {
                    current.status = 'Abweichung';
                    errCnt++;
                }
                current.value_ref = ref.value;
            } else {
                current.status = 'Kein Referenzwert';
                errCnt++;
            }
        });
        Object.keys(refData).forEach((k: string) => {
            const current = flatData[k];
            const ref = refData[k];
            if (!current && ref) {
                const key = `${ref.jahr}_${ref.kz}`;
                flatData[key] = {jahr: ref.jahr, kz: ref.kz, value: null, value_ref: ref.value, status: 'Kein aktueller Wert'};
                errCnt++;
            }
        });
        const keys = Object.keys(flatData);
        keys.sort();
        return <div style={{display: 'flex', flexDirection: 'column'}}>
            {this.renderHeader(errCnt)}
            {keys.filter((k: any) => !this.state.onlyErrors || flatData[k].status !== 'OK')
                .map((k: any, idx: number) => this.renderRow(flatData[k], idx))
            }
        </div>;
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label='Datencheck'
                helpKey='dateneingabe_datencheck'
                type='info'
                editBar
            />
        );
    }

    renderRow(row: any, idx: number): JSX.Element {
        const bgColor: string = (row || {}).status === 'OK' ? '#afa' : '#faa';
        const styleOverflow: any = { minWidth: 56, overflow: 'hidden', textOverflow: 'ellipsis' };
        return <div
            key={`row-${idx}`}
            style={{ display: 'flex', flexDirection: 'row', flex: 1, fontSize: 10, borderBottom: '1px solid #aaa' }}
        >
            <div style={{ width: 50, minWidth: 22, padding: 2 }}>{idx + 1}</div>
            <div style={{ width: 50, minWidth: 22, padding: 2 }}>{row.jahr}</div>
            <div style={{ width: 300, padding: 2, ...styleOverflow }}>{row.kz}</div>
            <div style={{ width: 300, padding: 2, ...styleOverflow }}>{row.value}</div>
            <div style={{ width: 300, padding: 2, ...styleOverflow }}>{row.value_ref}</div>
            <div style={{ width: 300, padding: 2, backgroundColor: bgColor }}>{row.status}</div>
            <div />
        </div>;
    }

    renderHeader(errCnt: number): JSX.Element {
        return <div
            style={{
                display: 'flex', flexDirection: 'column', fontSize: 10, backgroundColor: 'white', borderBottom: '1px solid #aaa',
                position: 'sticky', top: 0
            }}
        >
            <div
                style={{
                    padding: 2, display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'
                }}
            >
                <div>
                    <button onClick={() => this.save()}>
                        Snapshot speichern
                    </button>
                    &nbsp;
                    <input
                        type='checkbox'
                        checked={this.state.onlyErrors}
                        onChange={(evt: any) => this.setState({ onlyErrors: evt.target.checked })}
                    />
                    Nur Fehler anzeigen ({errCnt})
                </div>
                <div>{this.renderHelpIcon()}</div>
            </div>
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                <div style={{ width: 50, minWidth: 22, padding: 2 }}>#</div>
                <div style={{ width: 50, minWidth: 22, padding: 2 }}>Jahr</div>
                <div style={{ width: 300, minWidth: 56, padding: 2 }}>Kennzahl</div>
                <div style={{ width: 300, minWidth: 56, padding: 2 }}>Wert</div>
                <div style={{ width: 300, minWidth: 56, padding: 2 }}>Wert (Ref.)</div>
                <div style={{ width: 300, padding: 2 }}>Status</div>
                <div />
            </div>
        </div>;
    }

    private flattenData(): any {
        const flatData: any = {};
        const kennzahlen = this.props.data[IDs.KENNZIFFERN_BERECHNET];
        // console.log('KZ:', kennzahlen);
        Object.keys(kennzahlen).forEach((jahr: string) => {
            if (isNaN(+jahr)) {
                return;
            }
            const kz_jahr = kennzahlen[jahr];
            Object.keys(kz_jahr).forEach((kz: string) => {
                const value = kz_jahr[kz];
                if (Array.isArray(value)) {
                    value.forEach((item: any) => {
                        const key = `${jahr}_${kz}_${item.name}`;
                        const value_item = item.value;
                        if (value_item) {
                            // console.log('S3', key);
                            flatData[key] = {jahr, kz: `${kz}_${item.name}`, value: value_item};

                        }
                    })
                } else
                if (  typeof value === 'object') {
                    const key = `${jahr}_${kz}`;
                    flatData[key] = { jahr, kz, value: JSON.stringify(value)};
                } else if (value && !Array.isArray(value) && kz !== 'jahr') {
                    const key = `${jahr}_${kz}`;
                    flatData[key] = { jahr, kz, value };
                    // console.log('KZ:', jahr, kz, value, JSON.stringify(flatData[key]));
                }
                // console.log('KZ?', jahr, kz, value);
                if (value) {
                    try {
                        const a = btoa(JSON.stringify(value).replaceAll('₂', '2').replaceAll('€', 'EUR'));
                    } catch (ex) {
                        console.log('BAD VALUE: ', JSON.stringify(value).replaceAll('₂', '2').replaceAll('€', 'EUR'));
                    }
                }
            });
        });
        return JSON.parse(JSON.stringify(flatData).replaceAll('₂', '2').replaceAll('€', 'EUR'));
    }
}
